import React, { useEffect } from 'react';
import { PurchaseDocumentDataForm } from '../../../../app/models/PurchaseDocument';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import InputButtonFile from '../../../../components/inputs/InputButtonFile';

interface Props {
    purchaseDocument: PurchaseDocumentDataForm;
    setPurchaseDocument: (purchaseDocument: PurchaseDocumentDataForm) => void;
    errorFields?: any;
    disabled?: boolean;

}

const PurchaseDocumentDetailForm = ({ purchaseDocument, setPurchaseDocument, errorFields,disabled }: Props) => {


    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors, errors } = useHandleErrorFields();


    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields, setErrors]);
    
    const handleChange = (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;

        setPurchaseDocument({ ...purchaseDocument, [name]: value });
    };

    const handleChangeDocumentFile = (e: FileList | null, type: string) => {
        if (e) {
            setPurchaseDocument({ ...purchaseDocument, ['file']: e[0] });
        }
    };

    const handleRemoveFile = (name: string) => {
        setPurchaseDocument({ 
            ...purchaseDocument, 
            [name]: undefined 
        });
        const fileInput = document.getElementById(name) as HTMLInputElement | null;
        if (fileInput) {
            fileInput.value = '';
        }
    };
    return (
        <div className="purchase-document-detail-form">
            {/* Información del Documento */}
            <div className="h2 mt-0 mb-2 card-title">Información del Documento</div>

            <div className="form-group mb-3">
                <label htmlFor="tipo_documento">Tipo de Documento:</label>
                <input
                    type="text"
                    id="tipo_documento"
                    className="form-control"
                    value={purchaseDocument.document_type_obj?.name || ''}
                    disabled
                />
            </div>

            {purchaseDocument.document_type !== "FACTURA" && purchaseDocument.note_type && purchaseDocument.cause_note && (
            <>
                <div className="form-group mb-3">
                    <label htmlFor="note_type">Tipo de Nota:</label>
                    <input
                        type="text"
                        id="note_type"
                        className="form-control"
                        value={purchaseDocument.note_type}
                        disabled
                    />
                </div>
                <div className="form-group mb-3">
                    <label htmlFor="cause_note">Motivo:</label>
                    <input
                        type="text"
                        id="cause_note"
                        className="form-control"
                        value={purchaseDocument.cause_note.name}
                        disabled
                    />
                </div>
                <div className="form-group mb-3">
                    <label htmlFor="related_document">Nro Documento Relacionado:</label>
                    <input
                        type="text"
                        id="related_document"
                        className="form-control"
                        value={purchaseDocument.related_document?.document_number || ''}
                        onClick={() => {
                            if (purchaseDocument.related_document?.id) {
                                window.open(`${window.location.origin}/tax-documents/${purchaseDocument.related_document.id}/edit`, '_blank');
                            }
                        }}
                        readOnly
                        style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}
                    />
                </div>
            </>
        )}

            {/* Espacio adicional */}
            <div className="mt-3"></div>

            {/* Fecha de Emisión and Folio */}
            <div className="form-group-row" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label htmlFor="issueDate">Fecha de Emisión:</label>
                        <input
                            type="date"
                            className="form-control"
                            id="issue_date"
                            name="issue_date"
                            value={purchaseDocument.issue_date}
                            onChange={handleChange}
                            onFocus={() => onFocusRemove('issue_date')}
                            disabled={disabled}
                        />
                        <div className="invalid-feedback" style={{ display: 'flex', minHeight: '20px', alignItems: 'center' }}>
                            {fieldErrorMessage('issue_date')}
                        </div>
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label htmlFor="folio">Folio:</label>
                        <input
                            className={`form-control ${fieldHasError('folio')}`}
                            name="folio"
                            id="folio"
                            type="text"
                            value={purchaseDocument.folio}
                            onChange={handleChange}
                            placeholder="Ingrese el folio del documento"
                            onFocus={() => onFocusRemove('folio')}
                            disabled={disabled}
                        />
                        <div className="invalid-feedback" style={{ display: 'flex', minHeight: '20px', alignItems: 'center' }}>
                            {fieldErrorMessage('folio')}
                        </div>
                    </div>
                </div>

            {/* Espacio adicional */}
            <div className="mt-3"></div>
            {/* Datos del Emisor */}
            <div className="h2 mt-0 mb-2 card-title">Datos del Emisor</div>
            <div className="form-group mb-3">
                <label htmlFor="receiverClient">Proveedor:</label>
                <input
                    type="text"
                    id="receiverClient"
                    className="form-control"
                    value={purchaseDocument?.provider_name || ''}
                    disabled
                />
            </div>
            <div className="form-group mb-3">
                <label htmlFor="receiverAddress">Direccion:</label>
                <input
                    type="text"
                    id="receiverAddress"
                    className="form-control"
                    value={purchaseDocument?.provider_address || ''}
                    disabled
                />
            </div>
            <div className="form-group mb-3">
                <label htmlFor="receiverEmail">Email:</label>
                <input
                    type="text"
                    id="receiverEmail"
                    className="form-control"
                    value={purchaseDocument?.provider_email || ''}
                    disabled
                />
            </div>
            {/* Datos del Receptor */}
            {/* <h4>Datos del Emisor</h4> */}
            <div className="h2 mt-0 mb-2 card-title">Datos del Receptor</div>
            <div className="form-group mb-3">
                <label htmlFor="issuerSociety">Sociedad:</label>
                <input
                    type="text"
                    id="issuerSociety"
                    className="form-control"
                    value={purchaseDocument?.society_name || ''}
                    disabled
                />
            </div>
            <div className="form-group mb-3">
                <label htmlFor="issuerAddress">Direccion:</label>
                <input
                    type="text"
                    id="issuerAddress"
                    className="form-control"
                    value={purchaseDocument?.society_address || ''}
                    disabled
                />
            </div>
            <div className="form-group mb-3">
                <label htmlFor="issuerEmail">Email:</label>
                <input
                    type="text"
                    id="issuerEmail"
                    className="form-control"
                    value={purchaseDocument?.society_email || ''}
                    disabled
                />
            </div>
            <div className="mb-2 row">
                <div className="col-md-6">
                    <label htmlFor="receiverEmail">Documento de Venta:</label>
                    {
                        disabled ? (
                            purchaseDocument.file ? (
                        
                                    <div>
                                        <a
                                            href={String(purchaseDocument.file)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-success btn-sm"
                                            role="button"
                                            aria-pressed="true"
                                        >
                                            Documento
                                        </a>
                                    </div>
                                ) : (
                                    <div>
                                        <p>No tiene documento</p>
                                    </div>
                                )
                        )
                        :
                        (
<>
                        <InputButtonFile
                            name="file"
                            objectFile={purchaseDocument.file}
                            handleChangeDocumentFile={handleChangeDocumentFile}
                            handleRemoveFile={(value: any) => handleRemoveFile('file')}
                            onFocus={() => onFocusRemove('file')}
                                disabled={disabled}
                        />
                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('file')}
                        </div>
                        </>
                        )
                        
                    }
                    
                </div>
            </div>
        </div>
    );
};

export default PurchaseDocumentDetailForm;
